module.exports = __webpack_public_path__ + "static/img/008.8952356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-head/008.png
// module id = ay2F
// module chunks = 1